module.exports = __webpack_public_path__ + "img/odt.b2c3682d.svg";